import { FC } from 'react';

interface Props {
    title?: string;
    children: string | JSX.Element;
    className?: string;
}

const Fieldset: FC<Props> = (props) => {
    return (
        <div
            className={`${props.className ?? ''} border border-custom-gray-03 my-[10px] px-[15px] pt-[20px] pb-[15px] relative w-full`}
        >
            {props.title && (
                <span className="bg-white text-[#555] font-bold left-[10px] px-[5px] py-0 absolute top-[-10px] inline-block">
                    {props.title}
                </span>
            )}
            {props.children}
        </div>
    );
};

export default Fieldset;
